var r = /* @__PURE__ */ ((e) => (e.Next = "next", e.Previous = "previous", e))(r || {});
const t = 5e3;
export {
  r as DirectionsEnum,
  t as INTERVAL_IN_MILLISECOND
};
